import React, { Component } from "react";
import "../common/DamageToggleButton.css";
import { configuration } from "../../appConfig";

export default class DamageToggleButton extends Component {
  render() {
    const { lang,showReportDamageImages,handleToggleDamageImages } = this.props;
    return (
      <>
      {configuration.getVersionUrl == "https://backend.drivenscan.live" ?
        <>
        <div className="d-flex align-items-center image_replace_toogle">
        {/* <span>{lang("Damage Images")} :</span> */}
        {/* <span>{("H")} </span> */}
        <span className="main_switchbar_wrapper_images">
          <label className="switch">
            <input
              className="switch-input"
              type="checkbox"
              name="showExtraImages"
              value={showReportDamageImages}
              checked={showReportDamageImages}
              onClick={(e) =>
                handleToggleDamageImages(e)
              }
            />
            <span
              className="switch-label"
              data-on={lang("Damages_1")}
              data-off={lang("H")}
            ></span>
            <span className="switch-handle"></span>
          </label>
        </span>
        {/* <span className="d-flex align-items-center">{("D")}  &nbsp;</span> */}
      </div>

        </>
        :
        <>
        <div className="d-flex align-items-center">
        <span>{lang("Damage Images")} :</span>
        <span className="main_switchbar_wrapper_images">
          <label className="switch">
            <input
              className="switch-input"
              type="checkbox"
              name="showExtraImages"
              value={showReportDamageImages}
              checked={showReportDamageImages}
              onClick={(e) =>
                handleToggleDamageImages(e)
              }
            />
            <span
              className="switch-label"
              data-on={lang("Yes")}
              data-off={lang("No")}
            ></span>
            <span className="switch-handle"></span>
          </label>
        </span>
        </div>
        </> }
        </>
    );
  }
}